<template>
  <v-form
    v-if="isShown"
    class="filter white mb-5"
    @submit.prevent="submit"
  >
    <v-container fluid>
      <v-row>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('common.name') }}
            </label>
            <v-text-field
              v-model="localFilter.name"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">E-mail</label>
            <v-text-field
              v-model="localFilter.email"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">ASDB</label>
            <v-text-field
              v-model="localFilter.asdb"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="2">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('common.role') }}
            </label>
            <v-select
              v-model="localFilter.role"
              :items="roles"
              item-text="name"
              item-value="name"
              solo
              hide-details
            />
          </div>
        </v-col>
        <v-col
          cols="2"
          offset="2"
          class="filter__apply"
        >
          <v-btn
            type="submit"
            color="primary"
            outlined
            large
            class="filter__apply-button"
          >
            {{ $t('common.apply') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'UserListFilter',

  model: {
    prop: 'isShown',
  },

  props: {
    isShown: {
      type: Boolean,
      default: false,
    },

    filter: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      localFilter: {
        name: '',
        email: '',
        asdb: '',
        role: '',
      },

      roles: [],
      loading: false,
    };
  },

  watch: {
    isShown(value) {
      if (value) {
        this.init();
      }
    },
  },

  created() {
    this.getRoles();
  },

  methods: {
    init() {
      this.localFilter = { ...this.filter };
    },

    submit() {
      this.$emit('applyFilter', this.localFilter);
    },

    async getRoles() {
      this.loading = true;
      try {
        const { data = {} } = await this.$http.get('roles');
        this.roles = data.rows;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
